import { z } from 'zod';

export const autocompleteResultSchema = z.object({
    title: z.string(),
    url: z.string(),
    category: z.string().nullable(),
    source: z.string().nullable(),
});

export const autocompleteResultsSchema = z.array(autocompleteResultSchema);

export const getAutocompleteResultsResponseSchema = z.object({
    allResults: z
        .object({
            results: z.array(autocompleteResultSchema),
        })
        .nullable(),
    doesContainProfanity: z.boolean(),
});
